var chunkMapping = {
	"50": [
		1050
	],
	"357": [
		824,
		846,
		3279,
		6164,
		6246,
		8585
	],
	"525": [
		7525
	],
	"614": [
		4614
	],
	"675": [
		2675
	],
	"718": [
		718
	],
	"719": [
		1719
	],
	"754": [
		6967
	],
	"847": [
		8847
	],
	"901": [
		9901
	],
	"910": [
		7910
	]
};
var idToExternalAndNameMapping = {
	"718": [
		"default",
		"./VendorIncomeDetails",
		4590
	],
	"824": [
		"default",
		"./GlobalProviders",
		5918
	],
	"846": [
		"default",
		"./component-auth",
		9794
	],
	"1050": [
		"default",
		"./DeductionDetails",
		4590
	],
	"1719": [
		"default",
		"./SPMDetails",
		4590
	],
	"2675": [
		"default",
		"./Deductions",
		4590
	],
	"3279": [
		"default",
		"./UnauthorizedCard",
		5918
	],
	"4614": [
		"default",
		"./Payments",
		4590
	],
	"6164": [
		"default",
		"./react-query",
		9794
	],
	"6246": [
		"default",
		"./httpRequest",
		4718
	],
	"6967": [
		"default",
		"./component-logging",
		9794
	],
	"7525": [
		"default",
		"./RouterWrapper",
		5918
	],
	"7910": [
		"default",
		"./ContactUs",
		814
	],
	"8585": [
		"default",
		"./BaseViewLayout",
		5918
	],
	"8847": [
		"default",
		"./PaymentDetails",
		4590
	],
	"9901": [
		"default",
		"./TreckDeductionDetails",
		4590
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}